const NotFound = () => {
  return (
    <div className="w-full hd-f1:h-[91vh] hd-f4:h-[92vh] hd-f6:h-[90vh] hd-f9:h-[94vh] flex flex-col items-center">
      <div>Página não encontrada</div>
    </div>
  );
};

export default NotFound;
